import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'

import {config} from '../config'

export default class CloudManager {
  /**
   * 初期化のタイミングでCloudのインスタンス化、デバイスIDを発行する。デバイスIDはすでに発行されている場合は上書きされない
   */
  constructor () {
    /**
     * Cloud(Firebase)の初期化インスタンス
     * @type {number}
     * @private
     */
    if (!firebase.apps.length) {
      this.cloudApp = firebase.initializeApp(config.firebaseConfig)
    }
  }

  /**
   * IDから探索して商品データを返す
   * @param  {string} id ユニークID
   * @return {object} 商品データ（Promise形式で返却）
   */
  getItem (id) {
    const dbRef = this.cloudApp.database().ref('items/' + id)

    return this.getPromiseData(dbRef)
  }

  /**
   * すべての商品データを返す
   * @return {object} 商品データ（Promise形式で返却）
   */
  getAllItems () {
    const dbRef = this.cloudApp.database().ref('items')

    return this.getPromiseData(dbRef)
  }

  getBrand (brandID) {
    const dbRef = this.cloudApp.database().ref('brand/' + brandID)

    return this.getPromiseData(dbRef)
  }

  /**
   * 全てのブランドデータを返す
   * @return {array} ブランドデータ（Promise形式で返却）
   */
  getAllBrands () {
    const dbRef = this.cloudApp.database().ref('brand')

    return this.getPromiseData(dbRef)
  }

  /**
   * カスタマイズIDに紐づけて、カスタム商品データを保存する
   * @param  {object} json 保存するデータオブジェクト
   */
  setCustomItem (json) {
    const dbRef = this.cloudApp.database()

    return new Promise((resolve, reject) => {
      dbRef.ref('customItems/' + json['customID']).set(json).then(() => {
        resolve()
      }).catch((error) => {
        reject(new Error(error))
      })
    })
  }

  /**
   * カスタム画像を保存する
   * @param  {array} images - 画像配列
   */
  putCustomItemImages (images) {
    const storageRef = this.cloudApp.storage().ref()
    const putImagePromises = []

    return new Promise((resolve, reject) => {
      images.forEach(image => {
        const putImagePromise = new Promise((resolve, reject) => {
          const filePath = 'custom/' + image['filename']
          storageRef.child(filePath).put(image['src']).then(function (snapshot) {
            resolve(snapshot)
          })
        })
        putImagePromises.push(putImagePromise)
      })

      Promise.all(putImagePromises).then(() => {
        resolve(true)
      }).catch((error) => {
        reject(new Error(error))
      })
    })
  }

  setCustomItemValue (customID, key, value) {
    return new Promise((resolve, reject) => {
      this.cloudApp.database().ref('customItems/' + customID + '/' + key).set(value).then(() => {
        resolve()
      })
    })
  }

  getCustomItemValue (customID, key) {
    const dbRef = this.cloudApp.database().ref('customItems/' + customID + '/' + key)

    return this.getPromiseData(dbRef)
  }

  /**
   * カスタマイズIDに一致したカスタム商品データを返す
   * @return {Object} カスタム商品データ（Promise形式で返却）
   */
  getCustomItem (customID) {
    const dbRef = this.cloudApp.database().ref('customItems/' + customID)

    return this.getPromiseData(dbRef)
  }

  /**
   * 全てのカスタム商品データを返す
   * @return {Object} カスタム商品データ（Promise形式で返却）
   */
  getAllCustomItems () {
    const dbRef = this.cloudApp.database().ref('customItems')
    return this.getPromiseData(dbRef)
  }

  /**
   * カスタマイズIDに一致したカスタム商品データを返す
   * @return {Object} カスタム商品データ（Promise形式で返却）
   */
  setOneTimePasswordData (deviceID, customID, password) {
    return new Promise((resolve, reject) => {
      this.cloudApp.database().ref('oneTimePasswords/' + deviceID).set({
        'customID': customID,
        'password': password
      }).then(() => {
        resolve()
      })
    })
  }

  /**
   * 全てのカスタム商品データを返す
   * @return {Object} カスタム商品データ（Promise形式で返却）
   */
  removeOneTimePasswordData (deviceID) {
    return new Promise((resolve, reject) => {
      this.cloudApp.database().ref('oneTimePasswords/' + deviceID).remove().then(() => {
        resolve()
      })
    })
  }

  /**
   * 全てのカスタム商品データを返す
   * @return {Object} カスタム商品データ（Promise形式で返却）
   */
  getAllOneTimePasswordsData () {
    const dbRef = this.cloudApp.database().ref('oneTimePasswords')
    return this.getPromiseData(dbRef)
  }

  /**
   * @private
   * カスタマイズIDに一致したカスタム商品データを返す
   * @param {any} dbRef firebaseのrefファイル
   * @return {any} データ（Promise形式で返却）
   */
  getPromiseData (dbRef) {
    return new Promise((resolve, reject) => {
      dbRef.once('value').then((snapshot) => {
        const data = snapshot.val()
        if (typeof data !== 'undefined') {
          resolve(data)
        } else {
          reject(new Error('something bad happened'))
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/CloudManager.js